import Mock from './Mock';

export default class ActivityAreaServiceMock {
  static getFile() {
    return Mock.call();
  }

  static addAttachedFile() {
    return Mock.call();
  }

  static getAttachedFile() {
    return Mock.call();
  }

  static getAttachedFiles() {
    return Mock.call();
  }
}
